import { isIPInCIDR } from './isIPInCIDR'

/**
 * Check if a client IP matches any entry in a bypass list.
 * Supports individual IPs and CIDR notation.
 *
 * @param clientIP - The client's IPv4 address
 * @param bypassList - Array of IPs or CIDR ranges to match against
 * @returns True if the client IP matches any entry in the bypass list
 */
export const isIPBypassed = (clientIP: string, bypassList: string[]): boolean =>
    bypassList.some((entry) => (entry.includes('/') ? isIPInCIDR(clientIP, entry) : clientIP === entry))
